var paragraph_default = {
  "fontElementMap": "_0M38d",
  "elementSpacing": "Mvhwh",
  "text": "wLdeF Mvhwh",
  "child": "afd3P"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
